import { render, staticRenderFns } from "./jump.vue?vue&type=template&id=51761f08&scoped=true&"
import script from "./jump.vue?vue&type=script&lang=ts&"
export * from "./jump.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51761f08",
  null
  
)

export default component.exports